import { useTranslation } from "react-i18next";

// Inactive MAS Report Table
const InactiveMASTable = ({ inactiveMasData }) => {
  const { t } = useTranslation();
  return (
    <div className="services-table-wrapper">
      <table className="services-table">
        <thead>
          <tr>
            <th>{t("mass_name_label")}</th>         
            <th>{t("region_label")}</th>
            <th>{t("service_name_label")}</th>
            <th>{t("plan_name_label")}</th>
            <th>{t("mass_code_label")}</th>
            <th>{t("status_label")}</th>
            <th>{t("order_date_label")}</th>
            <th>{t("release_date_label")}</th>
            <th>{t("end_date_label")}</th>
            <th>{t("invoice_number_label")}</th>
            <th>{t("price_label")}</th>
            <th>{t("auto_debit_label")}</th>
            <th>Post Invoice Status</th>
            <th>Post Invoice Push Timestamp</th>
            <th>Auto Debit Repurchase</th>
            <th>InsertMass Push Status</th>
            <th>InsertMass Push Timestamp</th>
            <th>SAP Push Status</th>
            <th>SAP Push Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {inactiveMasData && inactiveMasData.length > 0 ? (
            inactiveMasData.map((service, index) => (
              <TableRow key={index} service={service} />
            ))
          ) : (
            <tr>
              <td colSpan="19" className="px-6 py-4 text-center">
                {t("no_data_available")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
const TableRow = ({ service }) => {
  const { t } = useTranslation();

  const formatDate = (dateStr) => {
    return dateStr ? new Date(dateStr).toLocaleDateString() : "";
  };

  return (
    <tr>
      <td data-label={t("mass_name_label")}>{service.massName}</td>
      <td data-label={t("region_label")}>{service.region}</td>
      <td data-label={t("service_name_label")}>{service.serviceName}</td>
      <td data-label={t("plan_name_label")}>{service.planName}</td>
      <td data-label={t("mass_code_label")}>{service.massCode}</td>
      <td data-label={t("status_label")}>{service.status}</td>
      <td data-label={t("order_date_label")}>{formatDate(service.orderDate)}</td>
      <td data-label={t("release_date_label")}>{formatDate(service.releaseDate)}</td>
      <td data-label={t("end_date_label")}>{formatDate(service.endDate)}</td>
      <td data-label={t("invoice_number_label")}>
        {service.invoiceNumber || "-"}
      </td>
       <td data-label={t("price_label")}>
        {service.price !== undefined && service.price !== null && !isNaN(service.price)
          ? Number(service.price).toFixed(2)
          : "-"}
      </td>
      <td data-label={t("auto_debit_label")}>
        {service.autoDebit
          ? ["yes", "true"].includes(service.autoDebit.toLowerCase())
            ? t("yes")
            : t("no")
          : ""}
      </td>
      <td data-label="Post Invoice Status">
        {service.dmsPostInvoicesStatus === "1"
          ? "Pushed"
          : service.dmsPostInvoicesStatus === "0"
          ? "Failed"
          : "-"}
      </td>
      <td data-label="Post Invoice Push Timestamp">
        {service.dmsPostInvoicesTimestamp
          ? new Date(service.dmsPostInvoicesTimestamp).toLocaleString()
          : "-"}
      </td>
      <td data-label="Auto Debit Repurchase">
        {service.autoDebitRepurchase || "-"}
      </td>
      <td data-label="InsertMass Push Status">
        {service.insertMassPushStatus === "1"
          ? "Pushed"
          : service.insertMassPushStatus === "0"
          ? "Failed"
          : "-"}
      </td>
      <td data-label="InsertMass Push Timestamp">
        {service.insertMassPushTimestamp
          ? new Date(service.insertMassPushTimestamp).toLocaleString()
          : "-"}
      </td>
      <td data-label="SAP Push Status">
        {service.sapPushStatus === "1"
          ? "Confirmed"
          : service.sapPushStatus === "0"
          ? "Failed"
          : "-"}
      </td>
      <td data-label="SAP Push Timestamp">
        {service.sapPushTimestamp
          ? new Date(service.sapPushTimestamp).toLocaleString()
          : "-"}
      </td>
    </tr>
  );
};



export default InactiveMASTable;